<template>
  <b-overlay :show="showLoading" rounded="sm">
    <nav class="main-header bg-main-header navbar navbar-expand navbar-white navbar-light">
      <!-- Left navbar links: below 992px AdminLTE hides the sidebar off-canvas, so this
           toggle (AdminLTE PushMenu widget) is the only way to open it on tablet / mobile -->
      <ul class="navbar-nav d-lg-none">
        <li class="nav-item">
          <a class="nav-link text-white" data-widget="pushmenu" href="#" role="button" :title="TranslateText('Menu')">
            <i class="fas fa-bars"></i>
          </a>
        </li>
      </ul>
      <!--<ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link" data-widget="pushmenu" href="#" role="button"><i class="fas fa-bars"></i></a>
      </li>
      <li class="nav-item d-none d-sm-inline-block">
        <a href="../../index3.html" class="nav-link">Home1</a>
      </li>
      <li class="nav-item d-none d-sm-inline-block">
        <a href="#" class="nav-link">Contact</a>
      </li>
    </ul>-->
      <!-- Right navbar links -->
      <ul class="navbar-nav ml-auto">
        <!-- Navbar Search -->
        <!--<li class="nav-item">
        <a class="nav-link" data-widget="navbar-search" href="#" role="button">
          <i class="fas fa-search"></i>
        </a>
        <div class="navbar-search-block">
          <form class="form-inline">
            <div class="input-group input-group-sm">
              <input class="form-control form-control-navbar" type="search" placeholder="Search" aria-label="Search">
              <div class="input-group-append">
                <button class="btn btn-navbar" type="submit">
                  <i class="fas fa-search"></i>
                </button>
                <button class="btn btn-navbar" type="button" data-widget="navbar-search">
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
          </form>
        </div>
      </li>-->
        <li class="nav-item dropdown user-menu">
          <a href="#" class="nav-link dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
            <i class="text-white fas fa-language" data-toggle="tooltip" data-placement="top" title="Language"></i>
            <span class="text-white d-none d-md-inline">{{currentLanguage}}</span>
          </a>
          <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right" style="left: inherit; right: 0px;">
            <div style="max-height: 600px;overflow:scroll;">
              <template v-if="languages !== null && languages !== undefined" v-for="item in languages">
                <a href="#" class="dropdown-item" @click="setActiveLanguage(item)">
                  <i class="fas fa-language mr-1"></i> {{item.languageName}}
                </a>
                <div class="dropdown-divider"></div>
              </template>
            </div>


            <div class="dropdown-divider"></div>
          </div>
        </li>

        <!-- Active Shift Dropdown Menu -->
        <li class="nav-item dropdown user-menu">

          <a href="#" class="nav-link dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
            <i class="text-white mdi mdi-account-multiple" data-toggle="tooltip" data-placement="top" :title="TranslateText('On Shifts')"></i>
            <span v-if="activeShift !== null && activeShift !== undefined" class="text-white d-none d-md-inline"><span class="font-weight-bold">{{activeShift.userName}}</span> on shift</span>
            <span v-else class="text-white d-none d-md-inline"> on shift</span>
          </a>
          <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right" style="left: inherit; right: 0px;">
            <template v-if="shifts !== null && shifts !== undefined" v-for="shift in shiftDisplayData">
              <a href="#" class="dropdown-item">
                <!-- Message Start -->
                <div class="media">
                  <!--<img src="/static/assets/img/avatar2.png" alt="User Avatar" class="img-size-50 mr-3 img-circle">-->
                  <div class="media-body">
                    <h3 class="dropdown-item-title" style="font-size: 0.8rem !important;">
                      Username: {{shift.userName}} {{shift.isActive ? ' - Current Shift' : '' }}
                      <!--<span class="float-right text-sm text-danger"><i class="fas fa-star"></i></span>-->
                    </h3>
                    <p class="text-sm text-muted" style="font-size: 0.7rem !important;">Start shift since: {{convertToGmtFn(shift.startedDate) | moment('DD MMM YYYY HH:mm:ss')}}</p>
                    <p class="text-sm text-muted" style="font-size: 0.7rem !important;"><i class="far fa-clock mr-1"></i> {{shift.timeDiff}} Ago</p>
                  </div>
                </div>
                <!-- Message End -->
              </a>
              <div class="dropdown-divider"></div>
            </template>

            <template v-if="shifts === null || shifts.length === 0">
              <a href="#" class="dropdown-item">
                <!-- Message Start -->
                <div class="media">
                  <!--<img src="/static/assets/img/avatar2.png" alt="User Avatar" class="img-size-50 mr-3 img-circle">-->
                  <div class="media-body">
                    <p class="text-sm">No on shift.</p>
                  </div>
                </div>
                <!-- Message End -->
              </a>
            </template>


          </div>
        </li>

        <!-- System Notification Dropdown Menu -->
        <li class="nav-item dropdown">
          <a class="nav-link" data-toggle="dropdown" href="#" aria-expanded="false">
            <div class="position-relative">
              <i class="text-white mdi mdi-bell" data-toggle="tooltip" title="System Notification"></i>
              <span v-if="systemNotifications && systemNotifications.length > 0"
                    class="badge badge-danger navbar-badge shadow-sm">
                {{ systemNotifications.length }}
              </span>
            </div>
          </a>

          <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right border-0 shadow-lg mt-2" style="width: 320px;">
            <!-- Header -->
            <div class="px-3 py-2 d-flex justify-content-between align-items-center bg-light rounded-top">
              <h6 class="dropdown-header p-0 text-dark font-weight-bold">Notifications</h6>
              <span v-if="systemNotifications && systemNotifications.length > 0" class="badge badge-pill badge-light border text-muted">
                {{ systemNotifications.length }} New
              </span>
            </div>

            <div class="dropdown-divider m-0"></div>

            <!-- Scrollable Content Area -->
            <div style="max-height: 400px; overflow-y: auto;">

              <!-- List Items -->
              <template v-if="systemNotifications && systemNotifications.length > 0">
                <div v-for="(item, index) in systemNotifications" :key="index" class="notification-wrapper position-relative border-bottom p-3">

                  <!-- Close Button -->
                  <button type="button" class="close position-absolute"
                          style="right: 10px; top: 10px; font-size: 1.2rem;"
                          aria-label="Close"
                          @click.stop="markAsRead(item.id)">
                    <span aria-hidden="true">&times;</span>
                  </button>

                  <div class="media">
                    <!-- Status Indicator Icon -->
                    <div :class="['mr-3 status-icon-circle', getStatusColorClass(item.status)]">
                      <i :class="getStatusIcon(item.status)"></i>
                    </div>

                    <div class="media-body mr-3">
                      <p class="mb-1 text-sm text-dark font-weight-600 line-height-sm">{{ item.message }}</p>
                      <small class="text-muted">
                        <i class="mdi mdi-clock-outline mr-1"></i>Status: {{ item.status }}
                      </small>
                    </div>
                  </div>
                </div>
              </template>

              <!-- Empty State -->
              <template v-else>
                <div class="py-5 text-center">
                  <i class="mdi mdi-bell-off-outline mdi-36px text-light-gray d-block mb-2"></i>
                  <p class="text-muted mb-0">No new notifications found</p>
                </div>
              </template>
            </div>

            <!-- Footer -->
            <!--<div class="dropdown-divider m-0"></div>
          <a href="#" class="dropdown-item dropdown-footer text-center text-primary font-weight-bold py-2">
            View All Notifications
          </a>-->
          </div>
        </li>

        <!-- System Notification Dropdown Menu -->
        <!--<li class="nav-item dropdown">
      <a class="nav-link" data-toggle="dropdown" href="#" aria-expanded="false">
        <i class="text-white mdi mdi-bell" data-toggle="tooltip" data-placement="top" title="System Notification"></i>
        <span class="badge badge-secondary navbar-badge">{{systemNotifications !== null ? systemNotifications.length : 0}}</span>
      </a>

      <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right" style="left: inherit; right: 0px;">

        <div class="dropdown-header text-sm text-bold">

          <div>Notification List</div>



        </div>
        <div class="dropdown-divider"></div>
        <div style="max-height: 600px;overflow-y:scroll;width:100%">
          <template v-if="systemNotifications !== null && systemNotifications.length !== 0" v-for="item in systemNotifications">
            <div>
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">×</button>
              <p class="dropdown-item-title text-wrap">{{item.message}}</p>
              <p class="text-sm text-muted">
                Status: {{item.status}}
              </p>
            </div>
            <div class="dropdown-divider"></div>
          </template>
        </div>
        <template v-if="systemNotifications === null || systemNotifications.length === 0">
          <a href="#" class="dropdown-item">-->
        <!-- Message Start -->
        <!--<div class="media">-->
        <!--<img src="/static/assets/img/avatar2.png" alt="User Avatar" class="img-size-50 mr-3 img-circle">-->
        <!--<div class="media-body">
          <p class="text-sm">No record found.</p>
        </div>
      </div>-->
        <!-- Message End -->
        <!--</a>
          </template>
        </div>
      </li>-->
        <!-- Cancelled Bed/Room Dropdown Menu -->
        <!--<li class="nav-item dropdown">
          <a class="nav-link" data-toggle="dropdown" href="#" aria-expanded="false">
            <div class="position-relative">
              <i class="text-white mdi mdi-sync-off" data-toggle="tooltip" data-placement="top" title="OTA Notification"></i>-->
              <!--<i class="mdi mdi-sync-off"></i>-->
              <!--<span class="badge badge-secondary navbar-badge">{{bookingsCancelled !== null ? bookingsCancelled.length : 0}}</span>
              </div>
          </a>

          <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right" style="left: inherit; right: 0px;">
            <div class="float-right pt-1 pb-1 pr-1" v-if="bookingsCancelled !== null && bookingsCancelled.length !== 0">
              <router-link :to="{ path: '/api/v2/Report/GetNotificationDownload', query: form }"
                           v-slot="{ href }"
                           custom>
                <b-button class="badge btn-light-custom btn-icon-size"
                          target="_blank" :href="href" variant="primary">
                  <i class="fas fa-regular fa-file-export"></i>
                </b-button>
              </router-link>
            </div>
            <div class="dropdown-header text-sm text-bold">

              <div>Notification List</div>



            </div>
            <div class="dropdown-divider"></div>
            <div style="max-height: 600px;overflow-y:scroll;width:100%">
              <template v-if="bookingsCancelled !== null && bookingsCancelled.length !== 0" v-for="cancelled in bookingsCancelled">
                <div href="#" :class="GetWarningClass(cancelled)" style="margin:0;" role="alert" @click.prevent.stop="takeActionOnModifyAndCancel(cancelled)">
                  <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click.prevent.stop="WarningModal(cancelled.bookingId)">×</button>
                  <p class="dropdown-item-title text-wrap">Order Code: {{cancelled.orderCode}} - {{cancelled.guestName}}</p>
                  <p class="text-sm">Arrival Date: {{cancelled.startDate | moment('DD/MM/YYYY')}}</p>
                  <p class="text-sm text-muted">
                    Status: {{GetRequestType(cancelled.requestType)}}
                  </p>
                </div>
                <div class="dropdown-divider"></div>
              </template>
            </div>
            <template v-if="bookingsCancelled === null || bookingsCancelled.length === 0">
              <a href="#" class="dropdown-item">-->
                <!-- Message Start -->
                <!--<div class="media">-->
                  <!--<img src="/static/assets/img/avatar2.png" alt="User Avatar" class="img-size-50 mr-3 img-circle">-->
                  <!--<div class="media-body">
                    <p class="text-sm">No record found.</p>
                  </div>
                </div>-->
                <!-- Message End -->
              <!--</a>
            </template>
          </div>
        </li>-->

        <!-- Question Mark Dropdown Menu -->
        <li class="nav-item dropdown">
          <a class="nav-link" data-toggle="dropdown" href="#" aria-expanded="false" @click="showChatBox">
            <div class="position-relative">
              <i class="text-white mdi mdi-message-text-outline m-1" data-toggle="tooltip" data-placement="top" title="Messages"></i>
              <span class="badge badge-secondary navbar-badge">{{totalUnread}}</span>
            </div>
          </a>
          <!--<div class="dropdown-menu dropdown-menu-lg dropdown-menu-right" style="left: inherit; right: 0px;">
        <a href="#" class="dropdown-item">-->
          <!-- Message Start -->
          <!--<div class="media">-->
          <!--<img src="/static/assets/img/avatar2.png" alt="User Avatar" class="img-size-50 mr-3 img-circle">-->
          <!--<div class="media-body">
            <p class="text-sm">No record found.</p>
          </div>
        </div>-->
          <!-- Message End -->
          <!--</a>

        </div>-->
        </li>
        <!-- Notifications Beds/Room Dropdown Menu -->
        <li class="nav-item dropdown">
          <a class="nav-link" data-toggle="dropdown" href="#" aria-expanded="false">
            <div class="position-relative">
              <i class="text-white mdi mdi-bed mr-2" data-toggle="tooltip" data-placement="top" title="Allocation Required"></i>
              <span class="badge badge-secondary navbar-badge">{{deallocatedRooms !== null ? deallocatedRooms.length : 0}}</span>
            </div>
          </a>
          <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right" style="left: inherit; right: 0px;height: 400px;overflow: scroll;">
            <div class="dropdown-header text-sm text-bold">

              <div>Allocation Required</div>

            </div>
            <div class="dropdown-divider"></div>

            <template v-if="deallocatedRooms !== null && deallocatedRooms.length !== 0" v-for="item in deallocatedRooms">
              <a href="#" class="dropdown-item dropdown-hover-deallocate" @click.prevent.stop="getBookingDetails(item.bookingId)">
                <!-- Message Start -->
                <div class="media">
                  <!--<img src="/static/assets/img/avatar2.png" alt="User Avatar" class="img-size-50 mr-3 img-circle">-->
                  <div class="media-body">

                    <p class="dropdown-item-title text-wrap">
                      {{item.orderCode}} - {{item.guestName}}
                      <!--<span class="float-right text-sm text-success"><i class="fas fa-star"></i></span>-->
                    </p>
                    <p class="text-sm">Stays: {{item.startDate | moment('DD MMM YY HH:mm')}} - {{item.endDate | moment('DD MMM YY HH:mm')}}</p>
                    <!--<p class="text-sm">Departure Date: </p>-->
                    <p class="text-sm">{{item.roomTypeName}}</p>
                    <p class="text-sm text-muted">
                      <!--<i class="far fa-clock mr-1"></i>-->
                      Status: {{GetBookingStatus(item.roomStatusId)}}
                    </p>
                    <!--<button type="button" class="box-arrow-down" >auto allocate</button>-->
                    <b-button block variant="outline-primary" :disabled="ajaxing" size="sm" @click.prevent.stop="autoAllocate(item)">Auto allocate</b-button>
                  </div>
                </div>
                <!-- Message End -->
              </a>
              <div class="dropdown-divider"></div>
            </template>
            <template v-if="deallocatedRooms === null || deallocatedRooms.length === 0">
              <a href="#" class="dropdown-item">
                <!-- Message Start -->
                <div class="media">
                  <div class="media-body">
                    <p class="text-sm">No record found.</p>
                  </div>
                </div>
                <!-- Message End -->
              </a>
            </template>
            <!--<a href="#" class="dropdown-item dropdown-footer">See All Nofications</a>-->
          </div>
        </li>

        <!-- Property Dropdown Menu -->
        <li class="nav-item dropdown user-menu">
          <a href="#" class="nav-link dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
            <i class="text-white fas fa-home" data-toggle="tooltip" data-placement="top" title="Property List"></i>
            <span class="text-white d-none d-md-inline">{{activeLocation === null ? '' : activeLocation.name}}</span>
          </a>
          <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right" style="left: inherit; right: 0px;">
            <span class="dropdown-item dropdown-header">Property List</span>
            <div class="dropdown-divider"></div>
            <div style="max-height: 600px;overflow:scroll;">
              <template v-if="locations !== null && locations !== undefined" v-for="item in locations">
                <span style="cursor: pointer;" class="dropdown-item" @click="setActiveLocation(item)">
                  <i class="fas fa-house-user mr-2"></i> {{item.name}}
                  <!--<span class="float-right text-muted text-sm">3 mins</span>-->
                </span>
                <div class="dropdown-divider"></div>
              </template>
            </div>


            <!--<a href="#" class="dropdown-item">-->
            <!--<i class="fas fa-users mr-2"></i> 8 friend requests
          <span class="float-right text-muted text-sm">12 hours</span>-->
            <!--<i class="fas fa-house-user mr-2"></i> Ultron Hotel
          </a>
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item">-->
            <!--<i class="fas fa-file mr-2"></i> 3 new reports
          <span class="float-right text-muted text-sm">2 days</span>-->
            <!--<i class="fas fa-house-user mr-2"></i> Ultron Hotel
          </a>-->
            <div class="dropdown-divider"></div>
            <!--<a href="#" class="dropdown-item dropdown-footer">See All Notifications</a>-->
          </div>
        </li>

        <li class="nav-item dropdown user-menu">
          <a href="#" class="nav-link dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
            <img src="/static/assets/img/avatar2.png" class="user-image img-circle elevation-2" alt="User Image">
            <span class="text-white d-none d-md-inline">{{user.fullName}}</span>
          </a>
          <ul class="dropdown-menu dropdown-menu-lg dropdown-menu-right" style="left: inherit; right: 0px;">
            <!-- User image -->
            <li class="user-header bg-primary">
              <img src="/static/assets/img/avatar2.png" class="img-circle elevation-2" alt="User Image">


              <p>
                {{user.fullName}}
                <small>Logged Time - {{loggedTime | moment('DD/MM/YYYY hh:mm')}}</small>
              </p>
            </li>
            <!-- Menu Body -->
            <!--<li class="user-body">
          <div class="row">
            <div class="col-4 text-center">
              <a href="#">Followers</a>
            </div>
            <div class="col-4 text-center">
              <a href="#">Sales</a>
            </div>
            <div class="col-4 text-center">
              <a href="#">Friends</a>
            </div>
          </div>-->
            <!-- /.row -->
            <!--</li>-->
            <!-- Menu Footer-->
            <li class="user-footer">
              <!--<a href="#" class="btn btn-default btn-flat">Profile</a>-->
              <a href="#" @click.prevent.stop="signOut" class="btn btn-default btn-flat float-right">Sign out</a>
            </li>
          </ul>
        </li>

      </ul>

      <b-modal id="chat-modal" body-class="modal-zero-padding" no-close-on-backdrop hide-footer hide-header modal-class="position-bottom-right-custom" v-model="isShowChatBox">
        <chat></chat>
      </b-modal>
      <b-modal v-if="bookingModifiedFromCM!=null"
               no-close-on-backdrop
               id="modal-request-cancel-action"
               size="xl" hide-footer
               :title="cancelModalTitle">




        <div class="row">
          <table class="table table-sm table-borderless">
            <thead>
              <tr>
                <td class="font-weight-bold text-center">S/N</td>
                <td class="font-weight-bold text-center">Name</td>
                <td class="font-weight-bold text-center">Room Type</td>
                <td class="font-weight-bold text-center">-</td>
                <td class="font-weight-bold text-center">Arrival Date</td>
                <td class="font-weight-bold text-center">Departure Date</td>
                <td class="font-weight-bold text-center">Nights</td>
                <td class="font-weight-bold text-center">Total</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, iitem) in bookingModifiedFromCM.roomStays">
                <td class="text-center align-middle">{{iitem + 1}}</td>
                <td class="text-center align-middle">{{iitem === 0 ? (bookingModifiedFromCM.guest.firstName + ' ' + bookingModifiedFromCM.guest.lastName ) : ''}}</td>
                <td class="text-center align-middle">{{item.roomTypeName}}</td>
                <td class="text-center align-middle">-</td>
                <td class="text-center align-middle">{{item.startDate | moment('DD MMM YYYY')}}</td>
                <td class="text-center align-middle">{{item.endDate | moment('DD MMM YYYY')}}</td>
                <td class="text-center align-middle">{{computeNumberOfNights(item.startDate,item.endDate)}}</td>
                <td class="text-center align-middle">{{item.displayTotalRate}}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!--<h5 class="text-wrap">Action:</h5>-->
        <hr>
        <div class="row d-flex justify-content-center">
          <b-button class="mt-3 col-2 mr-2" variant="primary" @click="ActionForCancellation(1)">Post All Charges</b-button>
          <b-button class="mt-3 col-2 mr-2" variant="primary" @click="ActionForCancellation(2)">Cancel All Charges</b-button>

          <b-button class="mt-3 col-2" @click="ActionForCancellation(3)">Others</b-button>
        </div>

      </b-modal>
    </nav>
    <b-alert v-if="showAlert"
             show
             variant="danger"
             class="floating-alert d-flex flex-column flex-md-row align-items-md-center justify-content-between">
      <div class="alert-text mb-2 mb-md-0">
        ⚠
        {{ TranslateText('System maintenance will begin soon. You will be automatically logged out in') }}
        <strong>{{ countdownTime }}</strong>.
        {{ TranslateText(' Please complete and save your work now — any uncompleted actions may not be saved.') }}
      </div>

      <b-button size="sm"
                variant="light"
                class="ml-md-3 align-self-md-end"
                @click="signOut">
        {{ TranslateText('Logout Now') }}
      </b-button>
    </b-alert>
  </b-overlay>
</template>


<script>

  import ShiftWorkApi from '../api/shift-work-api';

  import BookingApi from '../api/booking-api';

  import SystemNotificationApi from '../api/system-notification-api';

  import BookingChargeItemApi from '../api/booking-charge-item-api';

  import { EventBus } from '../components/EventBus';

  import pmsHub from '../store/modules/pms-hub';

  import Chat from '../components/chat/chat.vue';
  import resizeCallbacks from 'devextreme/core/utils/resize_callbacks';

  import { mapGetters } from 'vuex';

  import $ from 'jquery';

  import PropertyLogApi from '../api/property-log-api';
  import { mapState } from 'vuex';

  import VueRouter from 'vue-router'
  const { isNavigationFailure, NavigationFailureType } = VueRouter

  export default {
    props: {
      locations: {
        type: Array,
        required: false,
        default: []
      }
    },
    components: {
      Chat
    },
    data() {
      return {
        showAlert: false,
        countdown: 30,
        countdownTime:"",
        timer: null,
        showLoading: false,
        activeLocation: null,
        shifts: [],
        activeShift: null,
        deallocatedRooms: [],
        bookingsCancelled: [],
        myInterval: null,
        isShowChatBox: false,
        bookingModifiedFromCM: null,
        cancelModalTitle: "",
        cancelBookingId: 0,
        form: null,
        languages: [],
        ajaxing: false,
        systemNotifications: [],
        loggedTime: new Date()
      }
    },
    methods: {
      // AdminLTE's PushMenu drops the "sidebar-collapse" body class when the off-canvas menu is
      // opened on a small screen. If the window is then widened (tablet rotated to landscape,
      // browser resized) the desktop layout would show the full-width sidebar instead of the
      // mini one, so restore the mini state once we are back at the desktop breakpoint. The
      // timeout lets PushMenu's own resize handler run first.
      keepSidebarMiniOnDesktop: function () {
        setTimeout(function () {
          if (window.innerWidth >= 992) {
            document.body.classList.remove('sidebar-open', 'sidebar-closed');
            document.body.classList.add('sidebar-collapse');
          }
        }, 0);
      },
      // DevExtreme widgets (pivot grids, data grids, charts) size their inner areas in pixels
      // and only re-measure on a window resize. AdminLTE moves the content area with a 0.3s
      // margin-left transition when the sidebar opens, collapses or appears after a rotation,
      // so the widgets measured the old width and part of a grid ended up clipped and
      // unreachable. Re-measure once that transition has finished.
      relayoutWidgetsAfterSidebarTransition: function (e) {
        if (e.propertyName === 'margin-left' && e.target === e.currentTarget) {
          resizeCallbacks.fire();
        }
      },
      // Fallback for the same problem when no transition event arrives (a rotation that lands
      // on a breakpoint whose layout has no transition, or a browser that drops the event):
      // re-measure once more 400ms after the last resize, i.e. after AdminLTE's 300ms slide.
      relayoutWidgetsAfterResize: function () {
        clearTimeout(this._relayoutTimer);
        this._relayoutTimer = setTimeout(function () { resizeCallbacks.fire(); }, 400);
      },
       formatSeconds(seconds) {
        const totalSeconds = Number(seconds) || 0

        const minutes = Math.floor(totalSeconds / 60)
        const remainingSeconds = totalSeconds % 60

        return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`
      },

      startWarning() {
        this.showAlert = true;
      
      },

     
      resetBookingModifiedStatus: async function (bookingId) {


        var res = await BookingApi.resetBookingModifiedStatus(bookingId);

        this.$bvToast.toast(res.data.success ? 'Remove Notification Successful!' : res.data.message, {
          title: `System Message`,
          variant: res.data.success ? 'success' : 'danger',
          solid: true
        })



      },

      markBookingNotificationReaded: async function (bookingId) {
        try {

          await BookingApi.markBookingNotificationReaded(bookingId);

        } catch (ex) {
          this.$bvToast.toast(ex, {
            title: `System Message`,
            variant: 'danger',
            solid: true
          })


        }

      },

      WarningModal(bookingId) {

        this.$bvModal.msgBoxConfirm('Are you sure you want to delete this notification?', {
          title: 'Confirm Message',
          okVariant: 'danger',
          okTitle: 'Confirm',
          cancelTitle: 'Cancel',
        }).then(value => {
          if (value == true) {
            this.resetBookingModifiedStatus(bookingId);
          }
        });
      },
      getModifiedReservation: async function (bookingId) {
        try {

          let res = await BookingApi.getModifiedReservation(bookingId);

          this.bookingModifiedFromCM = res.data.data;

        } catch (ex) {
        }
      },
      setActiveLocation: async function (location) {
        this.activeLocation = location;
        this.$store.commit('SetActiveLocation', location);
        localStorage.setItem('activeLocation', JSON.stringify(location));
        //clears the selected date from local storage if selected other property
        localStorage.removeItem('selectedDate');
        // localStorage.removeItem('overviewSelectedDate');
        // localStorage.removeItem('overviewHourlySelectedDate');
        localStorage.removeItem('dpSelectedDate');

        let isRedirectToDashboard = false;

        if (this.bcItems.length > 0) {
          for (let i = 0; i < this.bcItems.length; i++) {

            if (this.bcItems[i].text == 'Booking Detail') {
              isRedirectToDashboard = true;
              break;
            }
            else if (this.bcItems[i].text == 'Create Journal Entry') {
              isRedirectToDashboard = true;
              break;
            }
            else if (this.bcItems[i].text == 'Edit Journal Entry') {
              isRedirectToDashboard = true;
              break;
            }
            else if (this.bcItems[i].text == 'View Add On') {
              isRedirectToDashboard = true;
              break;
            }
            else if (this.bcItems[i].text == 'Set Special Terms') {
              isRedirectToDashboard = true;
              break;
            }
            else if (this.bcItems[i].text == 'Setting') {
              isRedirectToDashboard = true;
              break;
            }
            else if (this.bcItems[i].text == 'View Floor Level') {
              isRedirectToDashboard = true;
              break;
            }
            else if (this.bcItems[i].text == 'View Room Image') {
              isRedirectToDashboard = true;
              break;
            }
          }
        }

        if (isRedirectToDashboard) {
          await this.$router.push({ path: '/Dashboard' });
        }

        this.$store.dispatch('permission/clearClearPermissions');

        this.$store.dispatch('permission/getUserPermissions');


        this.addPropertyLog(location.pvid);
      },
      setActiveLanguage: function (language) {

        if (language.languageName === this.currentLanguage) {
          return;
        }

        localStorage.setItem('lang', JSON.stringify(language));
        this.$router.go();
      },
      addPropertyLog: async function (pvid) {
        let model = {
          propertyId: pvid,
          userId: this.GetCurrentUserFn().userId
        }

        await PropertyLogApi.addPropertyLog(model);
      },
      signOut: function () {

        //localStorage.removeItem('activeLocation');
        localStorage.removeItem('access_details');
        //remove selected date from local storage
        localStorage.removeItem('selectedDate');
        // localStorage.removeItem('overviewSelectedDate');
        // localStorage.removeItem('overviewHourlySelectedDate');
        localStorage.removeItem('dpSelectedDate');
        this.$store.dispatch('permission/clearClearPermissions');
        this.$store.commit('SetUserDetails', null);
        window.location.href = "/login";

      },
      kickOut: function () {

        //localStorage.removeItem('activeLocation');
        localStorage.removeItem('access_details');
        //remove selected date from local storage
        localStorage.removeItem('selectedDate');
        // localStorage.removeItem('overviewSelectedDate');
        // localStorage.removeItem('overviewHourlySelectedDate');
        localStorage.removeItem('dpSelectedDate');
        this.$store.dispatch('permission/clearClearPermissions');
        this.$store.commit('SetUserDetails', null);
        window.location.href = "/Maintenance";

      },
      getShiftWorkActive: async function () {

        if (!this.activeLocation) {
          return;
        }

        try {

          let res = await ShiftWorkApi.getShiftActive(this.ActiveLocation.pvid, this.GetCurrentUserFn().userId);

          this.shifts = res.data.data;

          this.activeShift = this.$lodash.find(res.data.data, (sh) => { return sh.isActive });

          this.$store.commit('SetActiveShift', this.activeShift !== null && this.activeShift !== undefined ? this.activeShift : null);

        } catch (ex) {
        }
      },
      getDeallocatedRooms: async function () {
        if (this._deallocatedRoomsLoading) return;
        this._deallocatedRoomsLoading = true;
        try {

          let res = await BookingApi.getDeallocatedRooms(this.ActiveLocation.pvid);

          this.deallocatedRooms = res.data.data === null ? [] : res.data.data;

        } catch (ex) {
          clearInterval(this.myInterval);
        } finally {
          this._deallocatedRoomsLoading = false;
        }
      },
      getBookingCancelled: async function () {
        try {
          let res = await BookingApi.getBookingCancelled(this.ActiveLocation.pvid);
          this.bookingsCancelled = res.data.data === null ? [] : res.data.data;
        } catch (ex) {
          clearInterval(this.myInterval);
        }
      },
      getBookingDetails: async function (bookingId) {
        //this.$store.commit('SetIsShowModifiedReservation', true);
        //await this.markBookingNotificationReaded(bookingId);
        this.$router.push({ path: `/ReservationDetails/${Number(bookingId)}` });
      },

      takeActionOnModifyAndCancel: async function (cancelled) {

        /*        if (this.GetRequestType(cancelled.requestType) == 'Modify') {*/
        this.showLoading = true;

        /*   await this.resetBookingModifiedStatus(cancelled.bookingId);*/
        this.getBookingDetails(cancelled.bookingId);

        this.showLoading = false;

        //}
        //else {
        //  this.cancelModalTitle = "Request For Cancellation (Order Code:" + cancelled.orderCode + ")";
        //  this.cancelBookingId = cancelled.bookingId;
        //  await this.getModifiedReservation(cancelled.bookingId);
        //  this.$bvModal.show("modal-request-cancel-action");

        //}
      },
      GetRequestType: function (val) {

        switch (val.toString()) {
          case "Modify":
          case "2":
            return "Modify"
            break
          case "Cancel":
          case "3":
            return "Cancel"
            break
        }
      },
      PostAllCancelCharge: async function (bookingId) {
        var userId = this.$store.getters.GetCurrentUserFn().userId;
        var userName = this.$store.getters.GetCurrentUserFn().fullName;

        let res = await BookingChargeItemApi.postAllCancelCharge(bookingId, userId, userName);

        this.$bvToast.toast(res.data.success ? 'Post All Charges Successful!' : res.data.message, {
          title: `System Message`,
          variant: res.data.success ? 'success' : 'danger',
          solid: true
        })

      },

      CancelAllCancelCharge: async function (bookingId) {
        var userId = this.$store.getters.GetCurrentUserFn().userId;
        var userName = this.$store.getters.GetCurrentUserFn().fullName;

        let res = await BookingChargeItemApi.cancelAllCancelCharge(bookingId, userId, userName);

        this.$bvToast.toast(res.data.success ? 'Cancel All Charges Successful!' : res.data.message, {
          title: `System Message`,
          variant: res.data.success ? 'success' : 'danger',
          solid: true
        })

      },

      ActionForCancellation: async function (actionType) {
        this.showLoading = true;
        if (actionType == 1) {
          ///Post All charge
          await this.PostAllCancelCharge(this.cancelBookingId);
          /*    await this.resetBookingModifiedStatus(this.cancelBookingId);*/
          this.$bvModal.hide("modal-request-cancel-action");

        }
        else if (actionType == 2) {
          ///Cancel All Charge
          await this.CancelAllCancelCharge(this.cancelBookingId);
          /*         await this.resetBookingModifiedStatus(this.cancelBookingId);*/
          this.$bvModal.hide("modal-request-cancel-action");
        }
        else {

          this.$bvModal.hide("modal-request-cancel-action");
          /*  await this.resetBookingModifiedStatus(this.cancelBookingId);*/
          await this.getBookingDetails(this.cancelBookingId);

        }
        this.showLoading = false;
      },

      timeDiffCalc: function (dateFutureValue, dateNowValue) {

        let dateFuture = new Date(this.convertToGmtWithTimeNoFormat(dateFutureValue));


        let dateNow = new Date(this.convertToGmtFn(dateNowValue));



        let diffInMilliSeconds = Math.abs(dateFuture - dateNow) / 1000;

        // calculate days
        const days = Math.floor(diffInMilliSeconds / 86400);
        diffInMilliSeconds -= days * 86400;

        // calculate hours
        const hours = Math.floor(diffInMilliSeconds / 3600) % 24;
        diffInMilliSeconds -= hours * 3600;

        // calculate minutes
        const minutes = Math.floor(diffInMilliSeconds / 60) % 60;
        diffInMilliSeconds -= minutes * 60;

        let difference = '';
        if (days > 0) {
          difference += (days === 1) ? `${days} day, ` : `${days} days, `;
        }


        difference += (hours === 0 || hours === 1) ? `${hours} hour, ` : `${hours} hours, `;

        difference += (minutes === 0 || hours === 1) ? `${minutes} minutes` : `${minutes} minutes`;

        return difference;
      },
      showChatBox: function () {
        this.isShowChatBox = !this.isShowChatBox;
      },


      GetWarningClass: function (cancelled) {
        var stringClass = 'dropdown-item alert';

        if (cancelled.isRequestAction == true) {

          stringClass = stringClass + " alert-warning2";
        }
        if (cancelled.isNotificationReaded == false) {

          stringClass = stringClass + " font-weight-bold";

        }
        return stringClass

      },
      autoAllocate: async function (roomStayUpdate) {
        try {

          //if (!this.isRoomAvailable) {
          //  return;
          //}

          this.ajaxing = true;


          let shiftWork = this.$store.getters.GetActiveShift;


          let roomStay = {
            id: roomStayUpdate.roomStayId,
            startDate: this.$moment(roomStayUpdate.startDate).format("YYYY-MM-DD HH:mm"),
            endDate: this.$moment(roomStayUpdate.endDate).format("YYYY-MM-DD HH:mm"),
            roomId: 0,
            bedId: 0,
            roomTypeId: roomStayUpdate.roomTypeId,
            bookingId: roomStayUpdate.bookingId,
            roomStayGuests: [],
            chargeList: [],
            isPerNight: roomStayUpdate.isPerNight
          }


          let model = {
            propertyId: this.ActiveLocation.pvid,
            shiftWorkId: shiftWork !== null && shiftWork !== undefined ? shiftWork.shiftWorkId : 0,
            userId: this.$store.getters.GetCurrentUserFn().userId,
            userName: this.$store.getters.GetCurrentUserFn().fullName,
            roomStay: roomStay,
            roomStayStatusId: 2,
            freeUpgrade: true,
            isChangeRoom: false,
            roomStayedDate: this.$moment(roomStayUpdate.startDate).format("YYYY-MM-DD"),
            changeType: "changeRoom",
            isOta: false,
            isDeallocatedRoom: false,
            sectionAction: "AutoAssign"
          }


          let res = await BookingApi.autoAllocateRoom(model);

          this.$bvToast.toast(res.data.success ? 'Success' : res.data.message, {
            title: `Auto allocate`,
            variant: res.data.success ? 'success' : 'danger',
            solid: true
          })

          this.ajaxing = false;

          EventBus.$emit('reload-calendar');

          this.ajaxing = false;


        } catch (ex) {
          this.ajaxing = false;
        }
      },
      getAllSystemNotifications: async function () {
        try {
          let res = await SystemNotificationApi.GetAllSystemNotifications(this.ActiveLocation.pvid);
          this.systemNotifications = res.data.data === null ? [] : res.data.data;
        } catch (ex) {
        }
      },
      getStatusColorClass(status) {
        if (!status) return 'bg-soft-info';
        switch (status.toLowerCase()) {
          case 'success': return 'bg-soft-success';
          case 'warning': return 'bg-soft-warning';
          case 'error': return 'bg-soft-danger';
          case 'danger': return 'bg-soft-danger';
          default: return 'bg-soft-info';
        }
      },
      getStatusIcon(status) {
        if (!status) return 'mdi mdi-information';
        switch (status.toLowerCase()) {
          case 'success': return 'mdi mdi-check-circle';
          case 'warning': return 'mdi mdi-alert';
          case 'error': return 'mdi mdi-alert-circle';
          case 'danger': return 'mdi mdi-alert-circle';
          default: return 'mdi mdi-information';
        }
      },
      removeNotification(index) {
        this.systemNotifications.splice(index, 1);
      },
      markAsRead: async function (notificationId) {
        try {
          await SystemNotificationApi.MarkAsRead(notificationId);
          await this.getAllSystemNotifications();
        } catch (ex) {
        }
      }
    },
    mounted: async function () {

      window.addEventListener('resize', this.keepSidebarMiniOnDesktop);
      window.addEventListener('resize', this.relayoutWidgetsAfterResize);
      this._contentWrapper = document.querySelector('.content-wrapper');
      if (this._contentWrapper) this._contentWrapper.addEventListener('transitionend', this.relayoutWidgetsAfterSidebarTransition);

      const acl = this.$store.getters.GetActiveLocationFn();
      if (!acl) {
        this.signOut();
      }



      if (this.activeLocation === null) {
        let activeLocation = localStorage.getItem('activeLocation');
        if (activeLocation !== undefined && activeLocation !== null) {
          this.activeLocation = JSON.parse(activeLocation);
          this.$store.commit('SetActiveLocation', JSON.parse(activeLocation));
        } else {
          if (this.locations.length > 0) {
            this.activeLocation = this.locations[0];
            this.$store.commit('SetActiveLocation', this.locations[0]);
            localStorage.setItem('activeLocation', JSON.stringify(this.locations[0]));
          }
        }
        //added checker for login log global
        if (this.$store.getters.GetLoginLog() !== false)
          this.addPropertyLog(this.activeLocation.pvid);
      }

      //setInterval(() => {
      //
      //}, 5000)
      this.getAllSystemNotifications();

      $(function () {
        $('[data-toggle="tooltip"]').tooltip()
      })
      this._onReloadShifts = async () => {
        await this.getShiftWorkActive();
      };
      EventBus.$on('reloadGetActiveShifts', this._onReloadShifts);

      let initialLanguage = {
        isActive: true,
        languageName: "English",
        languageTranslated: []
      }

      let otherLanguage = this.GetOtherLanguage();

      this.languages = [initialLanguage];

      if (otherLanguage !== null && otherLanguage !== undefined) {
        this.languages = this.languages.concat(otherLanguage);
      }


    },
    created: async function () {

      await this.getShiftWorkActive();

      const self = this;

      pmsHub.client.on("NewDeallocatedRoom", function (newDeallocateRoom) {
        self.deallocatedRooms.unshift(newDeallocateRoom);
      });

      pmsHub.client.on("GetDeallocatedRooms", function (list) {
        self.deallocatedRooms = list;
      });

      pmsHub.client.on("RemoveDeallocatedRoom", function (removeDeallocateRoom) {
        self.deallocatedRooms = self.deallocatedRooms.filter((d) => { return d.bookingId !== removeDeallocateRoom.bookingId });
      });

      //pmsHub.client.on("NewCancelledBooking", function (data) {
      //  self.bookingsCancelled.push(data);
      //});

      //pmsHub.client.on("GetCancelledBookings", function (data) {
      //  self.bookingsCancelled = data;
      //});

      //pmsHub.client.on("RemoveCancelledBooking", function (data) {
      //  self.bookingsCancelled = self.deallocatedRooms.filter((d) => { return d.bookingId !== data.bookingId });
      //});

      pmsHub.client.on("SendMessages", function (data) {
        self.$store.dispatch('SetChatMessageList', data);
      });

      //pmsHub.clientSystemNotification.on("SendSystemNotification", function (data) {
      //  self.systemNotifications.push(data);
      //});

 
      //pmsHub.clientUserAccessHub.on("SendKickOutFlag", (data) => {


      //  if (data === "kick") {

      //    this.kickOut();
      //  }
        

      //});


      //pmsHub.clientUserAccessHub.on("SendCountDownFlag", (data) => {

      //    this.countdownTime = this.formatSeconds(data);
      //    this.startWarning();
        

      //});

      //pmsHub.clientShift.on("SendShiftSignal", function (data) {

     
       
      //  if (data === "update") {

      //    EventBus.$emit('reloadGetActiveShifts');
         
      //  }

      //});

      this._onCloseChatBox = () => {
        self.isShowChatBox = false;
      };
      EventBus.$on('closeChatBox', this._onCloseChatBox);

      pmsHub.client.onclose(() => {
        const propertyName = this.ActiveLocation.name.replace(/\s/g, '').toLowerCase();
        pmsHub.start(propertyName, "")
      })

      //pmsHub.clientSystemNotification.onclose(() => {
      //  const propertyName = this.ActiveLocation.name.replace(/\s/g, '').toLowerCase();
      //  pmsHub.startSystemNotification(this.ActiveLocation.pvid, "")
      //})

      //pmsHub.clientUserAccessHub.onclose(() => {

      //  pmsHub.loginJoinAccount()
      //})

      //pmsHub.clientShift.onclose(() => {
      //  const propertyName = this.ActiveLocation.name.replace(/\s/g, '').toLowerCase();
      //  pmsHub.startShift(this.ActiveLocation.pvid, "")
      //})

    },
    watch: {
      locations: function () {
        if (this.activeLocation === null) {
          if (this.locations.length > 0) {
            this.activeLocation = this.locations[0];
          }
        }
      },
      ActiveLocation: async function (newValue, oldValue) {

        let newValueTemp = newValue.name.replace(/\s/g, '').toLowerCase();
        let oldValueTemp = oldValue !== null && oldValue !== undefined ? oldValue.name.replace(/\s/g, '').toLowerCase() : '';

        if (pmsHub.client.state === 0) {
          pmsHub.start(newValueTemp, oldValueTemp)
          //pmsHub.startSystemNotification(newValue.pvid, oldValue !== null && oldValue !== undefined ? oldValue.pvid : '');
          //pmsHub.startShift(newValue.pvid, oldValue !== null && oldValue !== undefined ? oldValue.pvid : '');

          //pmsHub.loginJoinAccount();
        } else {
          pmsHub.client.invoke("JoinGroupRoom", `${newValueTemp}deallocate`, oldValue !== null && oldValue !== undefined ? `${oldValueTemp}deallocate` : '');
          //pmsHub.client.invoke("JoinGroupRoom", `${newValueTemp}bookingcancelled`, oldValue !== null && oldValue !== undefined ? `${oldValueTemp}bookingcancelled` : '');
          pmsHub.client.invoke("JoinGroupRoom", `${newValueTemp}messages`, oldValue !== null && oldValue !== undefined ? `${oldValueTemp}messages` : '');
          //pmsHub.clientSystemNotification.invoke("JoinGroupRoom", `Property_${newValue.pvid}_Notifications`, oldValue !== null && oldValue !== undefined ? `Property_${oldValue.pvid}_Notifications` : '');
          //pmsHub.clientShift.invoke("JoinGroupRoom", `Property_${newValue.pvid}_Shift`, oldValue !== null && oldValue !== undefined ? `Property_${oldValue.pvid}_Shift` : '');

          //pmsHub.clientUserAccessHub.invoke("JoinUserAccessRoom");
        }

        this.$store.dispatch('GetMessagesInfo');
        this.form = { propertyId: this.ActiveLocation.pvid };
        await Promise.all([this.getShiftWorkActive(), this.getDeallocatedRooms()]);
       // await this.getBookingCancelled();
      }
    },
    computed: {
      progress() {
        return (this.countdown / 30) * 100
      },
      user: function () {
        return this.$store.getters.GetCurrentUserFn();
      },
      ActiveLocation: function () {
        const acl = this.$store.getters.GetActiveLocation;
        return acl;
      },
      shiftDisplayData: function () {
        const now = new Date();
        return (this.shifts || []).map(shift => ({
          ...shift,
          timeDiff: this.timeDiffCalc(now, shift.startedDate)
        }));
      },

      ...mapGetters(['GetBookingStatus', 'GetCurrentUserFn', 'GetChatMessageList', 'GetLanguage', 'TranslateText', 'GetOtherLanguage']),
      currentLanguage: function () {
        return this.GetLanguage();
      },
      totalUnread: function () {
        let list = this.GetChatMessageList();
        if (list)
          return list.filter(l => { return !l.isRead }).length;
      },
      ...mapState('permission', {
        bcItems: state => state.breadcrumbItems
          .map(i => ({
            text: i.name,
            href: i.url,
          })).reverse()
      }),
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.keepSidebarMiniOnDesktop);
      window.removeEventListener('resize', this.relayoutWidgetsAfterResize);
      clearTimeout(this._relayoutTimer);
      if (this._contentWrapper) this._contentWrapper.removeEventListener('transitionend', this.relayoutWidgetsAfterSidebarTransition);
      if (this.timer) clearInterval(this.timer);
      if (this._onReloadShifts) EventBus.$off('reloadGetActiveShifts', this._onReloadShifts);
      if (this._onCloseChatBox) EventBus.$off('closeChatBox', this._onCloseChatBox);
      pmsHub.stopAll();
    }
  }
</script>

<style>
  .dropdown-item-title,
  .media-body p {
    white-space: normal !important;
    word-break: break-word;
  }
  .floating-alert {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9999;
    border-radius: 0;
  }
  .alert-warning2 {
    color: #856404 !important;
    background-color: #fff3cd !important;
    border-color: #ffeeba !important;
  }

    .alert-warning2:focus {
      color: #856404 !important;
      background-color: #ffd54d !important;
      border-color: #ffcc33 !important;
    }

    .alert-warning2:hover {
      color: #856404 !important;
      background-color: #ffd54d !important;
      border-color: #ffcc33 !important;
    }

  .bg-main-header {
    background-color: var(--header-bg-color) !important;
  }

  .position-bottom-right-custom .modal-dialog.modal-md {
    position: fixed;
    bottom: 0;
    right: 0;
    margin: 20px;
    width: 18%;
  }

  .dropdown-hover-deallocate:hover {
    color: white !important;
    background-color: #6c757d !important;
    border-color: #ffcc33 !important;
  }

  .modal-zero-padding {
    padding: 0 !important;
    margin: 0 !important;
    height: 580px !important;
    max-height: 580px !important;
  }

  /* Chat panel below lg: 18% of a phone is about 67px, which wrapped the "Chat" title letter by
     letter and left no room for messages. Use the full width with a small margin, and let the
     580px body shrink to the screen height and scroll instead (landscape phones are shorter). */
  @media (max-width: 991.98px) {
    .position-bottom-right-custom .modal-dialog.modal-md {
      left: 0;
      right: 0;
      width: auto;
      max-width: none;
      margin: 10px;
    }

    .modal-zero-padding {
      height: auto !important;
      max-height: calc(100vh - 20px) !important;
      overflow-y: auto;
    }
  }
</style>



<style scoped>
  /* Custom positioning for the badge on the bell icon */
  .navbar-badge {
    position: absolute;
    top: -5px;
    right: -5px;
    font-size: 0.6rem;
    padding: 2px 4px;
    border-radius: 50%;
  }

  /* Notification Wrapper Hover */
  .notification-wrapper {
    transition: background 0.2s ease;
    cursor: pointer;
  }

    .notification-wrapper:hover {
      background-color: #f8f9fa;
    }

  /* Status Icon Circle styling */
  .status-icon-circle {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    font-size: 1rem;
  }

  /* Soft color variations for the icons */
  .bg-soft-success {
    background-color: rgba(40, 167, 69, 0.12);
    color: #28a745;
  }

  .bg-soft-warning {
    background-color: rgba(255, 193, 7, 0.12);
    color: #ffc107;
  }

  .bg-soft-danger {
    background-color: rgba(220, 53, 69, 0.12);
    color: #dc3545;
  }

  .bg-soft-info {
    background-color: rgba(23, 162, 184, 0.12);
    color: #17a2b8;
  }

  /* Typography tweaks */
  .line-height-sm {
    line-height: 1.3;
  }

  .text-light-gray {
    color: #dee2e6;
  }

  .font-weight-600 {
    font-weight: 600;
  }

  .font-20 {
    font-size: 20px;
  }

  /* Custom Scrollbar */
  div::-webkit-scrollbar {
    width: 4px;
  }

  div::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  div::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Header.vue